import { FaTimes, FaThLarge } from 'react-icons/fa'
import logo from '../assets/Logo200.png'
import {NavLink} from 'react-router-dom'

import { LoginContext } from '../Context/Context'

import { useContext } from 'react'
import { SignOut } from './Firebase'

const Navbar = () => {
    const {loggedIn, setLoggedIn} = useContext(LoginContext)

    let navMenu = document.getElementById('nav-menu')

    function CloseNav() {
        navMenu.classList.remove('show-menu')
    }

    

    function ShowNav() {
        navMenu.classList.add('show-menu')
    }

    return (
        <header style={{backgroundImage:'linear-gradient(136deg, #747272 0%, #77888f 100%)'}}>

        <nav className='nav center'>

            <a className='nav_logo'>
                <img src={logo} alt='' className='nav_logo_img' />
                RUN
            </a>

            <div className='nav_menu' id='nav-menu'>           
                <ul className='nav_list'>
                    <li className='nav_item'> 
                    {loggedIn ?     <NavLink to='/menu' activeClassName='active'><a href='' className='nav_link'>Menu</a></NavLink> : null}
                    </li>
                    <li className='nav_item'>
                        {loggedIn ? <NavLink to='/multiplayer' activeClassName='active'><a href='' className='nav_link'>Multiplayer</a></NavLink> : null}
                    </li>
                    <li className='nav_item'> 
                        {loggedIn ? <NavLink to='/' activeClassName=''><a href='#menu' className='nav_link' onClick={() => {SignOut()}}>Logout</a></NavLink> 
                                :  <NavLink to='/' activeClassName=''><a href='#menu' className='nav_link'>Login</a></NavLink>}
                    </li>
                </ul>
                <div className="nav_close">
                    <FaTimes  onClick={CloseNav}/>
                </div>
            </div>
            
            
            <div className="nav_toggle">
                <FaThLarge onClick={ShowNav}/>
            </div>
        </nav>
        </header>
    )
}

export default Navbar
